import axios from "axios"
import { useFormik } from "formik"
import React, { useState } from "react"
import * as Yup from "yup"
import { ToastContainer, toast } from "react-toastify"
import { Form } from "react-bootstrap"
import { request } from "../services/request"
import { FPinterface } from "../services/authinterface"
import GradientBackground from "../components/common/GradientBackground"
import { Link } from "react-router-dom"

const Forgotpassword: React.FC = () => {
  const [resend, setResend] = useState(false)
  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Please enter Email").email("Please enter valid Email"),
  })
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        const params = {
          email: values.email,
        }

        const response = await request<FPinterface>({
          url: "/admin/forgotPassword",
          method: "POST",
          data: params,
        })
        if (response.success) {
          setResend(true)
          toast.success("Please check your email!")
        } else {
          console.error("Login failed:", response)
          toast.error("failed: " + response.message)
        }
      } catch (error: any) {
        if (axios.isAxiosError(error)) {
          // Handle Axios error
          if (error?.response) {
            // Server responded with a status other than 2xx
            toast.error(`${error?.response?.data?.message}`)
          } else if (error?.request) {
            // Request was made but no response received
            toast.error("failed: No response from server")
          } else {
            // Something else happened while setting up the request
            toast.error(`failed: Something went wrong`)
          }
        } else {
          // Handle non-Axios error
          toast.error("An unexpected error occurred")
        }
        console.error("failed:", error)
      }
    },
  })
  return (
    <section className='login-section'>
      <ToastContainer position='top-right' autoClose={2000} theme='light' />
      <div className='gradint-main-section'>
        <GradientBackground />
      </div>
      <div className='container'>
        <div className='mian-login-section'>
          <div className='login-container'>
            <div className='login-filed-container'>
              <div className='py-3.5 px-4  md:p-12  w-full login-title-section'>
                <h2 className='login-title font-Poppins-Medium text-xl  md:text-[26px] leading-[36px] tracking-[-0.2px] text-gray-700 mb-2 md:mb-4'>
                  Forgot password
                </h2>
                <form onSubmit={formik.handleSubmit} className='login-form'>
                  <div className='login-input-section input-section'>
                    <div className='flex items-center justify-between'>
                      <label htmlFor='' className='font-Poppins-Medium text-sm  text-[#414552]'>
                        Email
                      </label>
                    </div>
                    <Form.Control
                      type='email'
                      name='email'
                      placeholder='Enter your email'
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={!!formik.errors.email && formik.touched.email}
                    />
                    <span className='text-red-500 text-xs'>
                      {formik.touched.email && formik.errors.email}
                    </span>
                  </div>
                  <Link
                    to='/login'
                    className='font-Poppins-SemiBold text-[12px]  text-[#635bff] transition-all duration-300 ease-in-out hover:text-[rgb(26,31,54)]'
                  >
                    Back to Login
                  </Link>
                  {resend && (
                    <div className='mt-4'>
                      Can't received email?{" "}
                      <button
                        type='button'
                        className='text-[rgb(99,91,255)] font-Poppins-Medium text-sm'
                        onClick={() => {
                          setResend(false)
                          formik.handleSubmit()
                        }}
                      >
                        Resend
                      </button>
                    </div>
                  )}
                  {!resend && (
                    <button
                      type='submit'
                      className='submit-button w-full block mt-4 text-base text-white leading-[28px] px-4 py-2 bg-[rgb(99,91,255)] rounded-sm'
                    >
                      Send mail{" "}
                    </button>
                  )}
                </form>
              </div>
            </div>
            <div className='login-info-section '>
              <div className=''>
                <svg
                  aria-hidden='true'
                  width='16'
                  height='16'
                  viewBox='0 0 16 16'
                  xmlns='http://www.w3.org/2000/svg'
                  className='w-full max-w-[12px] min-w-[12px] h-[12px] mt-1'
                >
                  <path d='M8.75 11.25a1.25 1.25 0 1 0-1.5 0v1a.75.75 0 0 0 1.5 0v-1Z'></path>
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M3.5 4v2h-1a1 1 0 0 0-1 1v6a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3V7a1 1 0 0 0-1-1h-1V4a4 4 0 0 0-4-4h-1a4 4 0 0 0-4 4ZM11 6V4a2.5 2.5 0 0 0-2.5-2.5h-1A2.5 2.5 0 0 0 5 4v2h6Zm-8 7V7.5h10V13a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 13Z'
                  ></path>
                </svg>
                <p className='text-[13px] font-Poppins-Regular'>
                  Never share your Gunsens credentials.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Forgotpassword
